module.exports = __webpack_public_path__ + "static/media/boxesCrane6.31d3de02.png";